var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"uk-select uk-form-small uk-form-width-small",on:{"change":_vm.fireChange}},_vm._l((_vm.values),function(perPage){return _c('option',{domProps:{"value":perPage,"selected":perPage === _vm.appliedValue}},[_vm._v("\n        "+_vm._s(perPage)+"\n    ")])}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39e7b93a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/uikit3/assets/js/theme-components/grid/DataGridPerPage.vue
// module id = 7JHT
// module chunks = 0